import { NgModule } from '@angular/core';
import { WishlistContentErrorComponent } from './wishlist-content-error.component';

@NgModule({
  declarations: [WishlistContentErrorComponent],
  exports: [WishlistContentErrorComponent],
})
export class WishlistContentErrorModule {}
